import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, HostBinding, Input, OnChanges } from '@angular/core';

import {
    EventModel,
    EventScoreboard,
    SetGameScore,
    SpecialChar,
    TennisStatsEntry,
    getScorePoints,
} from '@frontend/sports/betting-offer/feature/model';
import { SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { SportConstant, TennisPeriodInfo } from '@frontend/sports/common/core/data-access/constants';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { EventTimerComponent } from '../../timers/event-timer.component';
import { BestOfComponent } from './best-of/best-of.component';
import { ScoreCardComponent } from './score-card.component';
import { ScoreboardParticipantComponent } from './scoreboard-participant.component';

@Component({
    selector: 'ms-set-game-scoreboard',
    templateUrl: 'set-game-scoreboard.component.html',
    imports: [
        NgClass,
        NgTemplateOutlet,
        EventTimerComponent,
        BestOfComponent,
        ScoreCardComponent,
        ParticipantImageComponent,
        ScoreboardParticipantComponent,
        IconCustomComponent,
    ],
})
export class SetGameScoreboardComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() scoreboard: EventScoreboard;
    @Input() isNewEDPScoreboard = false;
    @HostBinding('class') className = 'set-game';
    tieBreak?: TennisStatsEntry;
    isTennis = false;
    isSuspendedOrFinished = false;
    score: SetGameScore;
    isDoublesPlayer = false;
    setPoints: string[] = [];

    constructor(public sitecoreEventDetails: SitecoreEventDetailsConfig) {}

    ngOnChanges(): void {
        this.isTennis = this.event.sport.id === SportConstant.Tennis;
        this.score = this.event.scoreboard.getScore<SetGameScore>()!;
        this.setPoints = [getScorePoints(this.score.participant1.points)!, getScorePoints(this.score.participant2.points)!];
        this.isSuspendedOrFinished = !!this.event.scoreboard.period && this.event.scoreboard.period.id! in TennisPeriodInfo;
        this.isDoublesPlayer = this.event.participants.every((p) => p.name.includes(SpecialChar.Slash));
    }
}
